import { z } from 'zod';
import { ApplicantStage } from '../applicant-stage';
import { ReferralTrusteeRef } from './referral-review';

const count = z.number().int().min(0);

export const ReferralRate = z.object({
  count,
  percent: z.number().int().min(0).max(100).nullable(),
});
export type ReferralRate = z.infer<typeof ReferralRate>;

export const ReferralDashboardTrustee = z.object({
  trustee: ReferralTrusteeRef,
  referrals: count,
  families: count,
  children: count,
  byStage: z.record(ApplicantStage, count),
  byGrade: z.record(z.string(), count),
});
export type ReferralDashboardTrustee = z.infer<typeof ReferralDashboardTrustee>;

export const ReferralDashboard = z.object({
  referralsSubmitted: count,
  recommendations: count,
  familiesReferred: count,
  childrenReferred: count,
  awaitingReview: count,
  duplicatesPending: count,
  applicationRate: ReferralRate,
  enrollmentRate: ReferralRate,
  grades: z.array(z.string()),
  trustees: z.array(ReferralDashboardTrustee),
});
export type ReferralDashboard = z.infer<typeof ReferralDashboard>;

export const ReferralReportsQuery = z.object({
  cycleId: z.preprocess((v) => (v === '' ? undefined : v), z.string().uuid().optional()),
});
export type ReferralReportsQuery = z.infer<typeof ReferralReportsQuery>;

export const ReferralReportRow = z.object({
  key: z.string(),
  label: z.string(),
  referrals: count,
  children: count,
});
export type ReferralReportRow = z.infer<typeof ReferralReportRow>;

export const ReferralReports = z.object({
  cycleId: z.string().uuid().nullable(),
  totals: z.object({ referrals: count, families: count, children: count }),
  byGrade: z.array(ReferralReportRow),
  bySchool: z.array(ReferralReportRow),
  byTrustee: z.array(ReferralReportRow),
  byStage: z.array(ReferralReportRow),
  byMonth: z.array(ReferralReportRow),
});
export type ReferralReports = z.infer<typeof ReferralReports>;
